import wixmp from 'wixmp-sdk';

import parseVideo from './parsers/video';
import parseError from './parsers/error';

import parseUrl from './parse-url';

import * as http from '../../utils/http';


export default function (settings) {

  const facebookConnector = wixmp.connectExternalSource('FACEBOOK', settings);


  function _sendVideoGraphRequest(videoId) {
    return http.get(`${settings.apiUrl}/${videoId}`, {
      params: {
        fields: 'description,embed_html,format,from,id,name,source',
      },
      options: { withCredentials: false },
    });
  }

  function _sendVideoPixRequest(videoId) {
    return http.get(`${settings.fallbackApiUrl}/video`, {
      params: { video_id: videoId },
    });
  }

  function _parseResponse(response) {
    return parseVideo(response.data, settings)
      .then(_.castArray)
      .then(data => ({ ...response, data }));
  }


  function getByUrl(url) {
    return parseUrl(url)
      .then(function (videoId) {
        return _sendVideoGraphRequest(videoId)
          .then(_parseResponse);
      })
      .catch(parseError);
  }


  function getByUrlWithFBAuth(url) {
    return parseUrl(url)
      .then(function (videoId) {
        return _sendVideoGraphRequest(videoId)
          .catch(() => _sendVideoPixRequest(videoId))
          .catch(function (response) {
            if (response.status !== 403) {
              return Promise.reject(response);
            }

            return facebookConnector.connect()
              .then(() => _sendVideoPixRequest(videoId));
          })
          .then(_parseResponse);
      })
      .catch(parseError);
  }

  return {
    getByUrl,
    getByUrlWithFBAuth,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/facebook/videos.js